import mailConfigurationService from "@/services/generalSettings/mailConfigurationService";

const fallbackResponse = {
	status: "error",
	message: "Maximum file failed to retrieve.",
	data: { data: { maximum_file: "" } },
};

const setMaxSize = async () => {
	const code = "maximum_file";
	try {
		const response = await mailConfigurationService.get(code);
		if (response && response.data && response.data.data) {
			return { ...response.data, code };
		}
		return fallbackResponse;
	} catch {
        this.$toastNotifPrime('error', "Error", fallbackResponse.message);
		return fallbackResponse;
	}
};

export default setMaxSize;